import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppRoutes } from '../pages/App/App'

// useDocumentMeta: Sets the document title and <html lang> dynamically based on the current route and language.
// Keep the titleMap in sync with your app routes. If you add a new route, add its title key here.

export function useDocumentMeta() {
  const location = useLocation()
  const { t, i18n } = useTranslation()

  const titleMap: Record<string, string> = {
    [AppRoutes.ROOT]: 'WELCOME',
    [AppRoutes.OTP]: 'OTP_VERIFICATION',
    [AppRoutes.IDENTIFICATION]: 'CONFIRM_THE_DATA',
    [AppRoutes.EDIT_DOCUMENTS]: 'EDIT_DOCUMENT',
    [AppRoutes.UPLOAD_DOCUMENTS]: 'UPLOAD_DOCUMENTS',
    [AppRoutes.SIGN]: 'SIGN_DOCUMENT',
    [AppRoutes.FINISHED_SIGN]: 'OPERATION_FINISH',
    [AppRoutes.VALIDATE]: 'VALIDATE',
    [AppRoutes.QR_SIGN]: 'QR_SIGN'
  }

  useEffect(() => {
    const key = titleMap[location.pathname]
    const title = key ? t(key) + ' | Rubricae Onboarding' : 'Rubricae Onboarding'
    document.title = title
    document.documentElement.lang = i18n.language
  }, [location, t, i18n.language])
}
